import "../App.css"
import { useEffect, useState, useRef } from "react";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { createAvatarSynthesizer, createWebRTCConnection } from "../helpers/Utility";
import { AvatarConfiguration } from "../Config"
import { NavAvatarBar } from "../components/Nav"

import Toast from 'react-bootstrap/Toast';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import CryptoJS  from "crypto-js";

import { useSpeechToText } from '../components/SpeechToText';

const Secured = () => {
  const conf = JSON.parse(localStorage.getItem('config'))
  const imageUrl = conf.background;
  const myStyle = {
    backgroundImage: imageUrl,
    height: "100vh",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left 0px bottom"
  }


  const [show, setShow] = useState(false);
  const [avatarSynthesizer, setAvatarSynthesizer] = useState(null);
  const myAvatarVideoEleRef = useRef();
  const myAvatarAudioEleRef = useRef();
  const speechConfig = useRef(null);
  const audioConfig = useRef(null);
  const recognizer = useRef(null);
  const [startSessionForm, setStartSessionForm] = useState(false);
  const [hideInputBox, setHideInputBox] = useState(true);
  const [isHiddenInputBox, setIsHiddenInputBox] = useState(true);
  const [isHiddenNotifier, setIsHiddenNotifier] = useState(false);
  const [isHiddenTextInfo, setIsHiddenTextInfo] = useState(true);
  const [user, setUser] = useState([]);
  const [myTranscript, setMyTranscript] = useState("");
  const [retrivedDocuments, setRetrivedDocuments] = useState("");
  const [message, setMessage] = useState('');
  const [isButtonOnBarHidden, setIsButtonOnBarHidden] = useState(true);

  const {isListening ,resumeListening, stopListening, speech2TextVaule } = useSpeechToText();


  var iceUrl = AvatarConfiguration.iceUrl
  var iceUsername = AvatarConfiguration.iceUsername
  var iceCredential = AvatarConfiguration.iceCredential
  var previousAnimationFrameTimestamp = 0


  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Gestisci l'invio del messaggio
    toAIModel(message);
    console.log('Messaggio inviato:', message);
    setMessage('');
  };



  const generateSecurePathHash = (expires, uri,client_ip, secret) => {
    if (!expires || !uri ||  !secret) {
      return undefined;
    }

    const expiresTimestamp = Math.floor(Date.now() / 1000) + expires;
    const secureString = `${secret}${uri}${expiresTimestamp}`;


    const hash = CryptoJS.MD5(secureString).toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    return `${uri}?md5=${hash}&expires=${expiresTimestamp}`;

  }


  // Make video background transparent by matting
  const makeBackgroundTransparent = (timestamp) => {
    // Throttle the frame rate to 30 FPS to reduce CPU usage
    if (timestamp - previousAnimationFrameTimestamp > 30) {
      let video = document.getElementById('video')
      let tmpCanvas = document.getElementById('tmpCanvas')
      let tmpCanvasContext = tmpCanvas.getContext('2d', { willReadFrequently: true })
      tmpCanvasContext.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)
      if (video.videoWidth > 0) {
        let frame = tmpCanvasContext.getImageData(0, 0, video.videoWidth, video.videoHeight)
        for (let i = 0; i < frame.data.length / 4; i++) {
          let r = frame.data[i * 4 + 0]
          let g = frame.data[i * 4 + 1]
          let b = frame.data[i * 4 + 2]
          if (g - 150 > r + b) {
            // Set alpha to 0 for pixels that are close to green
            frame.data[i * 4 + 3] = 0
          } else if (g + g > r + b) {
            // Reduce green part of the green pixels to avoid green edge issue
            let adjustment = (g - (r + b) / 2) / 3
            r += adjustment
            g -= adjustment * 2
            b += adjustment
            frame.data[i * 4 + 0] = r
            frame.data[i * 4 + 1] = g
            frame.data[i * 4 + 2] = b
            // Reduce alpha part for green pixels to make the edge smoother
            let a = Math.max(0, 255 - adjustment * 4)
            frame.data[i * 4 + 3] = a
          }
        }

        let canvas = document.getElementById('canvas')
        let canvasContext = canvas.getContext('2d')
        canvasContext.putImageData(frame, 0, 0);
      }

      previousAnimationFrameTimestamp = timestamp
    }

    window.requestAnimationFrame(makeBackgroundTransparent)
  }



  const toAIModel = (message) => {

    
    setMyTranscript(message);
    if (isHiddenNotifier === false) {
      setShow(true);
    }

    query({ "question": message, "user": user.full_name, "name": user.name }).then((response) => {
      console.log(response);
      speakSelectedText(response.text);
      setIsHiddenTextInfo(true);
      let htmlPDFDocs = "";
      if ('sourceDocuments' in response) {
        htmlPDFDocs += "<b>Documenti di riferimento:<b><br/><br/>"
        let docs = []
        response.sourceDocuments.map(doc => { docs.push(doc.metadata.source) });

        let uniqueDocs = [...new Set(docs)];


        if (uniqueDocs.length > 0) htmlPDFDocs += "<ul>";
        uniqueDocs.map(doc => {
          let file = doc.replace("/root/client-data", "");
          const expiresInSeconds = 18000; // 1 ora
          console.log(file);
          let cr = generateSecurePathHash(expiresInSeconds, file,'', 'enigma');

          htmlPDFDocs += "<li><a href='" + process.env.REACT_APP_DOCUMENT_URL + cr + "'  target='_blank' >" + file.split('/').pop() + "</a></li>";
        });
        if (uniqueDocs.length > 0) { htmlPDFDocs += "</ul>"; setIsHiddenTextInfo(false); }
      }
      setRetrivedDocuments(htmlPDFDocs);


    });

  }



  async function query(data) {

    const conf = JSON.parse(localStorage.getItem('config'));

    const response = await fetch(
      "https://flowiseai.interlogica.ai/api/v1/prediction/" + conf.tenant,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );
    const result = await response.json();
    return result;
  }



  const handleOnTrack = (event) => {

    console.log("#### Printing handle onTrack ", event);

    // Update UI elements
    console.log("Printing event.track.kind ", event.track.kind);
    if (event.track.kind === 'video') {
      const mediaPlayer = myAvatarVideoEleRef.current;
      mediaPlayer.id = event.track.kind;
      mediaPlayer.srcObject = event.streams[0];
      mediaPlayer.autoplay = true;
      mediaPlayer.playsInline = true;
      let remoteVideoDiv = document.getElementById('remoteVideo');
      let video = document.getElementById('video');
      let canvas = document.getElementById('canvas');
      video.hidden = true;
      if (remoteVideoDiv != null) {
        remoteVideoDiv.style.width = '0.1px';

      }
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
      canvas.hidden = false;
      mediaPlayer.addEventListener('play', () => {
        window.requestAnimationFrame(makeBackgroundTransparent);
      });
    } else {
      // Mute the audio player to make sure it can auto play, will unmute it when speaking
      // Refer to https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
      //const mediaPlayer = myAvatarVideoEleRef.current;
      const audioPlayer = myAvatarAudioEleRef.current;
      audioPlayer.srcObject = event.streams[0];
      audioPlayer.autoplay = true;
      audioPlayer.playsInline = true;
      audioPlayer.muted = true;
    }
  };



  const speakSelectedText = (textToSpeak) => {

    //Start speaking the text
    const audioPlayer = myAvatarAudioEleRef.current;
    console.log("Audio muted status ", audioPlayer.muted);
    audioPlayer.muted = false;
    console.log("SPEAK:", textToSpeak);

    avatarSynthesizer.speakTextAsync(textToSpeak).then(
        (result) => {
          if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
            console.log("Speech and avatar synthesized to video stream.")
          } else {
            console.log("Unable to speak. Result ID: " + result.resultId)
            if (result.reason === SpeechSDK.ResultReason.Canceled) {
              let cancellationDetails = SpeechSDK.CancellationDetails.fromResult(result)
              console.log(cancellationDetails.reason)
              if (cancellationDetails.reason === SpeechSDK.CancellationReason.Error) {
                console.log(cancellationDetails.errorDetails)
              }
            }
          }
        }).catch((error) => {
          console.log(error)
          avatarSynthesizer.close()
        });
  


  }

  const startSession = () => {

    setStartSessionForm(true);
    setIsButtonOnBarHidden(false);
    if (hideInputBox === false) {
      setIsHiddenInputBox(hideInputBox);
    }
    let peerConnection = createWebRTCConnection(iceUrl, iceUsername, iceCredential);
    console.log("Peer connection ", peerConnection);
    peerConnection.ontrack = handleOnTrack;
    peerConnection.addTransceiver('video', { direction: 'sendrecv' })
    peerConnection.addTransceiver('audio', { direction: 'sendrecv' })

    let avatarSynthesizer  = createAvatarSynthesizer(AvatarConfiguration.videoCodec);
    setAvatarSynthesizer(avatarSynthesizer);
    peerConnection.oniceconnectionstatechange = e => {
      console.log("WebRTC status: " + peerConnection.iceConnectionState)

      if (peerConnection.iceConnectionState === 'connected') {
        console.log("Connected to Azure Avatar service");
      }

      if (peerConnection.iceConnectionState === 'disconnected' || peerConnection.iceConnectionState === 'failed') {
        console.log("Azure Avatar service Disconnected");
      }
    }

    avatarSynthesizer.startAvatarAsync(peerConnection).then((r) => {
      console.log("[" + (new Date()).toISOString() + "] Avatar started.")
      resumeListening();
    }).catch(
      (error) => {
        console.log("[" + (new Date()).toISOString() + "] Avatar failed to start. Error: " + error)
      }
    );
  }



  useEffect(() => {
   if (speech2TextVaule != '') {
    console.log('speech2TextVaule:', speech2TextVaule);
     toAIModel(speech2TextVaule);
   }
  },[ speech2TextVaule ]);


  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('user'));
    if (items) {
      setUser(items);
    }

    const conf = JSON.parse(localStorage.getItem('config'))

    if ('inputbox' in conf) {
      setHideInputBox(!conf.inputbox);
    }

    if ('notifier' in conf) {
      setIsHiddenNotifier(!conf.notifier);
    }


  }, []);



  return (
    <div>
      <NavAvatarBar title={process.env.REACT_APP_LABEL} hidden={isButtonOnBarHidden}  />
      <Toast className="position-absolute top-0 end-0" onClose={() => setShow(false)} show={show} delay={3000} autohide>
        <Toast.Header>
          <strong className="me-auto">Detected text</strong>
        </Toast.Header>
        <Toast.Body>{myTranscript}</Toast.Body>
      </Toast>


      <Card className="center-card-pa" hidden={startSessionForm} style={{ width: '40rem' }}>
        <Card.Img style={{ padding: '15px' }} variant="top" src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
        <Card.Body>
          <Card.Title>
          </Card.Title>
          <div>
            The following service is provided as a web preview and may be subject to changes, updates, or corrections without prior notice. User experience, features, and performance may vary during this preview phase. Users are aware that using the preview service carries potential risks, including system malfunctions, data loss, or other inconveniences. It is recommended that users utilize the preview service for testing and evaluation purposes only and not rely solely on it for critical or productive purposes. Access to the preview service is at the user's discretion. By pressing the "Start session" button, users acknowledge and accept the aforementioned conditions.
          </div>
        </Card.Body>
        <div class="col text-center">
          <Button variant="primary" onClick={() => startSession()} >Start session</Button>
        </div>
        <br></br>
      </Card>

      <div id="myAvatarVideo" style={myStyle} >
        <video id="remoteVideo" className="myAvatarVideoElement" ref={myAvatarVideoEleRef}></video>
        <canvas id="canvas" width="1920" height="1080" style={{ backgroundColor: 'transparent' }} hidden="hidden"></canvas>
        <canvas id="tmpCanvas" width="1920" height="1080" hidden="hidden"></canvas>
        <audio ref={myAvatarAudioEleRef}>
        </audio>
      </div>


      <div hidden={isHiddenTextInfo} className="bottom-corner-documents" dangerouslySetInnerHTML={{ __html: retrivedDocuments }} />


      <div className="bottom-corner" hidden={isHiddenInputBox} >
        <form onSubmit={handleSubmit} className="d-flex">
          <input
            type="text"
            className="form-control me-2"
            placeholder="Scrivi un messaggio..."
            value={message}
            onChange={handleChange}
          />
          <button type="submit" className="btn btn-primary">
            Invia
          </button>
        </form>
      </div>



    </div>
  );
};

export default Secured;